export default __webpack_public_path__ + "static/media/GH.f22fa1eb.svg";